<template>
  <div class="rounded border">
    <div
      class="flex flex-row items-center hover:bg-gray-100 cursor-pointer"
      :class="isOpen ? 'border-b' : ''"
      @click="toggleCollapse">
      <div class="flex-1 p-2">{{ title }}</div>
      <div class="flex-none px-2"><action-icons :icon="isOpen ? 'caret-up' : 'caret-down'" /></div>
    </div>
    <transition name="fade-fast">
      <div v-show="isOpen" key="content">
        <slot name="content">Your awesome content goes here</slot>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'collapsable-component',
  props: {
    title: {
      type: String,
      default: 'Colapsable'
    },
    initOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      contentHeight: 0
    }
  },
  mounted() {
    this.isOpen = this.initOpen;
  },
  methods: {
    toggleCollapse() {
      this.isOpen = !this.isOpen;
    }
  }
}
</script>